export const emptyValue = { none: 'None', dashLine: '---' };

export const SOURCE_FILTER_OPTIONS = [
  {
    key: 'CUSTOM',
    value: 'Custom Product'
  },
  {
    key: 'CROPWISE',
    value: 'Cropwise List'
  }
];

export const TYPE_FILTER_ADD_OPTIONS = [
  {
    key: 'CropProtection',
    value: 'Crop Protection'
  },
  {
    key: 'Fertilizer',
    value: 'Fertilizer'
  },
  {
    key: 'Seed',
    value: 'Seed'
  },
  {
    key: 'Service',
    value: 'Service'
  }
];

export const LIST_FILTER_OPTIONS = [
  {
    key: 'MyProductList',
    value: 'My Product List'
  },
  {
    key: 'AllProducts',
    value: 'All Products'
  }
];

export const PRODUCT_FILTER_OPTIONS = [
  {
    key: 'CROP_PROTECTION',
    value: 'Crop Protection'
  },
  {
    key: 'FERTILIZER',
    value: 'Fertilizer'
  },
  {
    key: 'SEED',
    value: 'Seed'
  },
  {
    key: 'SERVICE',
    value: 'Service'
  }
];
